import { AxiosInstance } from "axios"
import { ExternalServiceEntry } from "./extraServicesTypes"
import { ServiceResponse } from "../../../../core/api/apiTypes"

export enum ExtraServicesQuery {
    LIST = "extra-services-merchant",
    DETAILS = "extra-services-details-merchant",
    DELETE = "delete-extra-services-merchant",
}

// -- Fetch Extra Services --
type FetchExtraServicesParams = Readonly<{
    merchantId: number
}>

export type FetchExtraServicesResponse = {
    services: ExternalServiceEntry[]
}

export async function fetchExtraServices(
    { merchantId }: FetchExtraServicesParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchExtraServicesResponse> {
    const url = `/merchants/${merchantId}/services`

    const response = await axios.get(url, {
        signal,
    })

    return response.data
}

// -- Fetch Extra Service --
type FetchExtraServiceParams = Readonly<{
    extraServiceId: number
}>

export type FetchProductsResponse = {
    product: ExternalServiceEntry
}

export async function fetchExtraServiceDetails(
    { extraServiceId }: FetchExtraServiceParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchProductsResponse> {
    const url = `/products/${extraServiceId}`

    const response = await axios.get(url, {
        signal,
    })

    return response.data
}

// -- Create Extra Service --
type CreateExtraServiceParams = { product: ExternalServiceEntry }
type CreateExtraServiceResponse = ServiceResponse<{}>

export async function createExtraService(
    params: CreateExtraServiceParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<CreateExtraServiceResponse> {
    const { product } = params
    const response = await axios.post(
        "/extraServices",
        {
            product,
        },
        {
            signal,
        },
    )
    return response.data
}

// -- Create Extra Service --
export type UpdateExtraServiceBody = ExternalServiceEntry & {
    extraServiceId: number
}

type UpdateExtraServiceParams = {
    productId: number
    product: ExternalServiceEntry
}
type UpdateExtraServiceResponse = ServiceResponse<{}>

export async function updateExtraService(
    params: UpdateExtraServiceParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<UpdateExtraServiceResponse> {
    const { product, productId } = params
    const response = await axios.post(
        `/extraServices/${productId}`,
        {
            product: {
                ...product,
            },
        },
        {
            signal,
        },
    )
    return response.data
}

// -- Delete Extra Service --
type DeleteExtraServiceParams = Readonly<{
    productId: number
}>

export type DeleteExtraServiceResponse = ServiceResponse<{}>

export async function deleteExtraService(
    params: DeleteExtraServiceParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DeleteExtraServiceResponse> {
    const { productId } = params
    const url = `/products/${productId}`

    const response = await axios.delete(url, {
        signal,
    })

    return response.data
}

// -- Get product details --
type GetExtraServiceDetailsParams = Readonly<{
    productId: number
}>

export type GetExtraServiceDetailsResponse = {
    product: ExternalServiceEntry
}

export async function getProductDetails(
    params: GetExtraServiceDetailsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<GetExtraServiceDetailsResponse> {
    const { productId } = params
    const url = `/products/${productId}`

    const response = await axios.get(url, {
        signal,
    })

    return response.data
}
